import { useSyncExternalStore } from 'react';
import {
  getAuthVersion,
  getUserSettings,
  isLoggedIn,
  subscribeAuth,
  type UserSettings,
} from '@/api/auth';

export interface AuthSession {
  loggedIn: boolean;
  user: UserSettings | null;
  /** Bumps on every login / logout so consumers can key off changes. */
  version: number;
}

/**
 * Reactive player session. Re-renders when `login` / `clearSession` /
 * `handleUnauthorized` notify subscribers.
 */
export function useAuthSession(): AuthSession {
  const version = useSyncExternalStore(subscribeAuth, getAuthVersion, getAuthVersion);

  return {
    loggedIn: isLoggedIn(),
    user: getUserSettings(),
    version,
  };
}
